import { render } from "./Signups.vue?vue&type=template&id=b0e77c52"
import script from "./Signups.vue?vue&type=script&lang=js"
export * from "./Signups.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__